import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import type { AddonPersistedTabContent } from 'apiConnector/tabs/tabs.model';
import { ofType } from 'redux-observable';
import type { SchedulerLike } from 'rxjs';
import { EMPTY, of } from 'rxjs';
import { catchError, mergeMap, tap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { workspaceTabCreated } from 'state/workspaces/workspace.actions';
import { throwOnTimeout } from 'utils/rxjs';

export function createAddonTabEpic(timeoutInMillis: number = 60000, appScheduler?: SchedulerLike): EpicWithThunk {
  return (action$, _state$, { httpClient, navigateTo }) => {
    return action$.pipe(
      ofType('ADDON_TAB_CREATED'),
      mergeMap(({ tabId, productId, rfqId, tabName }) => {
        const content: AddonPersistedTabContent = {
          workspace: 'postTrade',
          tabType: 'addOn',
          productId,
          rfqId,
        };

        return tabsApiConnector(httpClient, 'postTrade')
          .updateTabContent(tabId, content)
          .pipe(
            throwOnTimeout(timeoutInMillis, `Timeout after ${timeoutInMillis}ms.`, appScheduler),
            mergeMap(() => of(workspaceTabCreated(tabId, content.workspace, content.tabType, tabName))),
            tap(() => navigateTo('/post-trade')),
            catchError(() => EMPTY),
          );
      }),
    );
  };
}
